import { render, staticRenderFns } from "./GuidePopup.vue?vue&type=template&id=27622a0c&scoped=true"
import script from "./GuidePopup.vue?vue&type=script&lang=ts"
export * from "./GuidePopup.vue?vue&type=script&lang=ts"
import style0 from "./GuidePopup.vue?vue&type=style&index=0&id=27622a0c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27622a0c",
  null
  
)

export default component.exports